import { render, staticRenderFns } from "./contactTodo.vue?vue&type=template&id=37ac3c24&scoped=true"
import script from "./contactTodo.vue?vue&type=script&lang=js"
export * from "./contactTodo.vue?vue&type=script&lang=js"
import style0 from "./contactTodo.vue?vue&type=style&index=0&id=37ac3c24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac3c24",
  null
  
)

export default component.exports